import { Component, ChangeDetectionStrategy, Input, Output, EventEmitter } from '@angular/core';

import * as State from '@shared/state';

import { ListsComponent } from '../../lists.shared.component';

@Component({
    selector: 'shared-list-for-history-order-items',
    templateUrl: './list-for-history-order-items.shared.component.html',
    styleUrls: ['./list-for-history-order-items.shared.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ListForHistoryOrderItemsComponent extends ListsComponent {
    @Input() public maxOnScreenHeight: string = null;
    @Input() public bottomPadding: boolean = false;
    @Input() public orderItems: OLO.Ordering.IOnlineOrderMappedProducts;

    constructor() {
        super();
    }

    public trackBy(index: number, orderItem: APICommon.IOnlineOrderItemModel | APICommon.IOnlineOrderMenuFlowActivation): number {
        return orderItem?.Id || index;
    }

}
